export default __webpack_public_path__ + "assets/images/Market-Leader-79c69ad7828ac856acd49ab88f52e10d.svg";